const RECOMMEND_GREETINGS = [
  '您还可以问我：',
  '我猜您还想了解：',
  '我猜您还感兴趣：',
  '您还可以了解：'
]

const getQueryVariable = function (variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return ''
}
const owner = getQueryVariable('owner')

function getRecommendGreeting () {
  const index = Math.floor(Math.random() * 4)
  return RECOMMEND_GREETINGS[index]
}

// eslint-disable-next-line no-extend-native
function httpHtml (val) {
  var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-|~)+)/g
  const arr = val.split('<a')
  const arr1 = []
  for (let i = 0; i < arr.length; i += 1) {
    const index = arr[i].indexOf('/a>')
    if (index === -1) {
      arr1.push(arr[i])
    } else {
      const r = arr[i].substr(index + 4).replace(reg, '<a target="_blank" href="$1$2" >$1$2</a>')
      arr1.push(arr[i].substr(0, index + 4) + r)
    }
  }
  return arr1.join('<a')
}

export default class AnswerModel {
  constructor (rsp) {
    if (rsp.askBack) {
      this.backask = this.handleAskBack(rsp.askBack && rsp.askBack.items)
    } else {
      this.backask = this.handleAskBack(rsp.backask && rsp.backask.items)
    }

    this.reply = this.handleReply(rsp.reply, rsp)

    this.objective = this.handleObjective(rsp.answer)
    this.recommend = this.handleRecommend(rsp.recommend)
    this.ttsUrl = rsp.ttsUrl || ''
  }

  handleReply (reply, _rsp) {
    if (typeof reply !== 'object') {
      return
    }

    reply.CardType = parseInt(reply.CardType) || 1
    reply.Title = reply.Title ? httpHtml(reply.Title) : ''
    reply.Items = reply.Items || []
    const _reply = {
      CardType: reply.CardType,
      empty: false
    }

    if (reply.CardType === 1) {
      if (owner) { // 上交大版本不显示命中盲区
        if (_rsp.source !== 'unknown') {
          _reply.Title =
            reply.Title && reply.Title.trim() ? reply.Title.trim().split('\n') : ''
          if (!_reply.Title) {
            _reply.empty = true
          }
        } else {
          _reply.empty = true
        }
      } else { // 其他命中盲区显示
        _reply.Title =
          reply.Title && reply.Title.trim() ? reply.Title.trim().split('\n') : ''
        if (!_reply.Title) {
          _reply.empty = true
        }
        _reply.recordId = reply.recordId
      }
    }

    if (reply.CardType === 2) {
      _reply.recordId = reply.recordId
      _reply.Items = reply.Items.filter(
        item => item.PicUrl || item.Title || item.Description || item.Url || item.Music
      ).map(item => ({
        PicUrl: item.PicUrl,
        Title: item.Title ? httpHtml(item.Title) : '',
        Description: item.Description.trim().split('\n'),
        Music: item.Music ? `${item.Music}?${this.GenNonDuplicateID().toString()}` : '',
        link_tip: item.link_tip || '查看更多',
        Url:
          item.Url &&
          (item.Url.indexOf('https://') !== 0
            ? item.Url.indexOf('http://') !== 0
              ? `http://${item.Url}`
              : item.Url
            : item.Url)
      }))
      if (!_reply.Items.length) {
        _reply.empty = true
      }
    }

    if (reply.CardType === 3) {
      _reply.recordId = reply.recordId
      _reply.Title = reply.Title
      _reply.Items = reply.Items.filter(
        item => item.Url || item.Title || item.PicUrl || item.Description
      ).map(item => ({
        Title: item.Title ? httpHtml(item.Title) : '',
        Description: item.Description,
        PicUrl: item.PicUrl,
        link_tip: item.link_tip || '查看更多',
        Url:
          item.Url &&
          (item.Url.indexOf('https://') !== 0
            ? item.Url.indexOf('http://') !== 0
              ? `http://${item.Url}`
              : item.Url
            : item.Url)
      }))
      if (!_reply.Items.length) {
        _reply.empty = true
      }
    }

    if (reply.CardType === 4) {
      _reply.recordId = reply.recordId
      _reply.Items = reply.Items.filter(item => item.PicUrl).map(item => ({
        PicUrl: item.PicUrl
      }))
      if (!_reply.Items.length) {
        _reply.empty = true
      }
    }
    return _reply
  }

  handleObjective (answer) {
    if (answer && answer.pushContents && answer.pushContents.CardType) {
      return this.handleReply(answer.pushContents)
    }
  }

  handleRecommend (recommend) {
    if (!recommend || !recommend.items || !Array.isArray(recommend.items)) {
      return
    }
    return {
      Title: recommend.prefix&&recommend.prefix!=='null' ? recommend.prefix : getRecommendGreeting(),
      Items: recommend.items.filter(item => item.question).map(item => item.question),
      PostfixTitle: recommend.postfix&&recommend.postfix!=='null' ? recommend.postfix : ''
    }
  }

  handleAskBack (askback) {
    if (!Array.isArray(askback)) {
      return
    }

    return {
      Items: askback.filter(item => item.askback).map(item => item.askback)
    }
  }
  GenNonDuplicateID (randomLength) {
    return Number(Math.random().toString().substr(3, randomLength) + Date.now()).toString(36)
  }
}



// WEBPACK FOOTER //
// ./src/app/GenH5/AnswerModel.js